import { UserUpload } from '../uploads';
import { EventName } from '../offline-events';
import { exampleBusiness } from '../business';
import { exampleUser, User } from '../user/User';

export interface BadDataSubmission {
  id: number;
  businessID: number;
  businessName: string;
  name: string;
  desc: string;
  startDate: string;
  endDate: string;
  eventName: EventName;
  uploads: UserUpload[];
  createdAt: number; // Unix timestamp
  submittedAt: number; // Unix timestamp
  submittedBy: User;
  approved: boolean;
  approvedAt?: number | null; // Unix timestamp
  approvedFeedback?: string;
  approvedBy?: User;
}

export const exampleBadDataSubmission: BadDataSubmission = {
  id: 1,
  businessID: exampleBusiness.id,
  businessName: 'Taco Joint',
  name: 'Bad Match Rate from Missing Emails',
  desc:
    'Forgot emails and it had a 20% match rate so I redid the upload as AddToCart',
  startDate: '',
  endDate: '',
  eventName: EventName.AddPaymentInfo,
  uploads: [],
  createdAt: 1595533091,
  submittedAt: 1595533091,
  submittedBy: exampleUser,
  approved: false,
  approvedAt: undefined,
  approvedBy: undefined,
  approvedFeedback: undefined,
};
